import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { unloadTech } from '../../../modules/techModule/tech';
import { unloadTechRslt } from '../../../modules/techModule/techRslt';
import TechListContainer from '../../../containers/techmng/support/TechListContainer';
import TechAddModalContainer from '../../../containers/techmng/support/TechAddModalContainer';
import TechEditStepperModalContainer from '../../../containers/techmng/support/TechEditStepperModalContainer';



const TechSupportTemplate = () => {
  const dispatch = useDispatch();
  const { project } = useSelector(({ techModule }) => ({
    project: techModule.project.project,
  }));


  const [reqId, setReqId] = useState(null);
  const [type, setType] = useState('add');
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);


  const handleClose = () => {
    setOpen(false);
    setType('add');
    setReqId(null);
    dispatch(unloadTech())
    dispatch(unloadTechRslt())
  };

  const selectedTech = (data) => {
    setReqId(data.reqUuid);
    setType('edit');
    setOpen(true);
  };

  if (!project) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        m: 1,
      }}
    >
      <TechListContainer selectedTech={selectedTech} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          my: 1
        }}
      >
        <Button
          variant="contained"
          color="info"
          onClick={handleOpen}
          sx={{ mr: 1 }}
        >
          신규지원 작성
        </Button>
      </Box>
      {type === 'add' ? (
        <TechAddModalContainer
          open={open}
          handleClose={handleClose}
          project={project}
        />
      ) : (
        <TechEditStepperModalContainer
          type={type}
          reqId={reqId}
          open={open}
          handleClose={handleClose}
          project={project}
        />
      )}
    </Box>
  );
};

export default TechSupportTemplate;
